import { getDefaultConfig } from "connectkit";
import { createConfig, http } from "wagmi";
import { base, baseSepolia, mainnet, sepolia } from "wagmi/chains";

export const wagmiConfig = createConfig(
    getDefaultConfig({
        chains: [mainnet, sepolia, base, baseSepolia],
        transports: {
            [mainnet.id]: http(),
            [sepolia.id]: http(),
            [base.id]: http(),
            [baseSepolia.id]: http(),
        },

        // Required API Keys
        walletConnectProjectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID ?? "",

        // Required App Info
        appName: "Your App Name",

        // Optional App Info
        appDescription: "Your App Description",
        appUrl: "https://family.co", // your app's url
        appIcon: "https://family.co/logo.png", // your app's icon, no bigger than 1024x1024px (max. 1MB)
    })
);

export const echoConfig = {
    apiURL: process.env.REACT_APP_ECHO_API_URL ?? "http://localhost:4000",
    frontendURL: process.env.REACT_APP_ECHO_FRONTEND_URL ?? "http://localhost:3000",
    clientUUID: process.env.REACT_APP_OAUTH_CLIENT_UUID ?? "da4e8c0c-f514-438a-adab-d7bb0ed4fc85",
    saleUUID: process.env.REACT_APP_SALE_UUID ?? "510f2069-69e3-4cb1-bed1-2ad49513ee80",
    callbackURL: process.env.REACT_APP_OAUTH_CALLBACK_URL ?? "http://localhost:3001/oauth/callback",
};
